import Vue from 'vue'
import VueRouter from 'vue-router'
import { isMobile } from '@/utils/device' // 设备检测工具

Vue.use(VueRouter)

// 移动端组件动态导入
const MobileLogin = () => import('@/views/mobile/MobileLogin.vue') // 更新文件名
const MobileOrderList = () => import('@/views/mobile/MobileOrderList.vue') // 更新文件名

// PC端组件保持原样
import MerchantLogin from '../views/MerchantLogin.vue'
import Manage from '../views/Manage.vue'
import Statistics from '../views/Statistics.vue'
import GoodsManage from '../views/GoodsManage.vue'
import OrderManage from '../views/OrderManage.vue'
import StoreManage from '../views/StoreManage.vue'
import ConsumerManage from '../views/ConsumerManage.vue'
import NewGoods from '../views/NewGoods.vue'
import EditGoods from '../views/EditGoods.vue'
import PCOrderDetail from '../views/PCOrderDetail.vue'
import AddStore from '../views/AddStore.vue'
import EditStore from '../views/EditStore.vue'
import MaliciousConsumer from '../views/MaliciousConsumer.vue'
import ConsumerDetails from '../views/ConsumerDetails.vue'


const routes = [
  {
    path: '/',
    redirect: isMobile() ? '/mobile/orders' : '/MerchantLogin'
  },
  // 登录路由 - 根据设备动态加载
  {
    path: '/MerchantLogin',
    name: 'MerchantLogin',
    component: isMobile() ? MobileLogin : MerchantLogin
  },
  // PC端管理后台路由
  {
    path: '/Manage',
    name: 'Manage',
    component: isMobile() ? MobileOrderList : Manage, // 移动端直接跳转到订单列表
    redirect: isMobile() ? null : '/Statistics', // 移动端不需要重定向
    children: [
      // PC端子路由 - 移动端不显示这些菜单
      ...(isMobile() ? [] : [
        {
          path: '/Statistics',
          name: 'Statistics',
          component: Statistics
        },
        {
          path: '/GoodsManage',
          name: 'GoodsManage',
          component: GoodsManage
        },
        {
          path: '/OrderManage',
          name: 'OrderManage',
          component: OrderManage
        },
        {
          path: '/StoreManage',
          name: 'StoreManage',
          component: StoreManage
        },
        {
          path: '/ConsumerManage',
          name: 'ConsumerManage',
          component: ConsumerManage
        },
        {
          path: '/NewGoods',
          name: 'NewGoods',
          component: NewGoods
        },
        {
          path: '/EditGoods',
          name: 'EditGoods',
          component: EditGoods
        },
        {
          path: '/order-detail/:id',
          name: 'PCOrderDetail',
          component: PCOrderDetail
        },
        {
          path: '/AddStore',
          name: 'AddStore',
          component: AddStore
        },
        {
          path: '/EditStore/:storeId',
          name: 'EditStore',
          component: EditStore
        },
        {
          path: '/MaliciousConsumer',
          name: 'MaliciousConsumer',
          component: MaliciousConsumer
        },
        {
          path: '/ConsumerDetails/:consumerId',
          name: 'ConsumerDetails',
          component: ConsumerDetails
        },
      ])
    ]
  },
  // 移动端专属路由
  {
    path: '/mobile/orders',
    name: 'MobileOrderList', // 更新路由名称
    component: MobileOrderList
  },
  {
    path: '/mobile/order-detail/:id',
    name: 'MobileOrderDetail',
    component: () => import('@/views/mobile/OrderDetail.vue')
  },
  {
    path: '/mobile/profile',
    name: 'MerchantProfile',
    component: () => import('@/views/mobile/MerchantProfile.vue')
  },
  {
    path: '/mobile/account',
    name: 'Account',
    component: () => import('@/views/mobile/Account.vue') // 请确保路径与实际组件位置一致
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 最简单的守卫实现
router.beforeEach((to, from, next) => {
  // 列出所有PC管理路由路径
  const pcManageRoutes = [
    '/Statistics',
    '/GoodsManage',
    '/OrderManage',
    '/StoreManage',
    '/ConsumerManage',
    '/NewGoods',
    '/EditGoods',
    '/order-detail/:id',
    '/AddStore',
    '/EditStore/:storeId',
    '/MaliciousConsumer',
    '/ConsumerDetails/:consumerId',
  ];

  // 移动端访问PC路由时重定向
  if (isMobile() && pcManageRoutes.includes(to.path)) {
    next('/mobile/orders');
  }
  // PC端访问移动端路由时重定向
  else if (!isMobile() && to.path.startsWith('/mobile/')) {
    next('/MerchantLogin');
  }
  else {
    next();
  }
})

export default router